module.exports = __webpack_public_path__ + "img/u27900.a5ffc6e3.png";